<template>
  <div class="full-sidebar">
    <div class="sidbar-first-section">
      <div class="form-group">
        <label for="expirationDate">
          <div class="label">New expiry date</div>
          <input
            type="date"
            name="expirationDate"
            id="expirationDate"
            class="field"
            required
            v-model="expirationDate"
            :disabled="selectedLicenses.length === 0"
          />
        </label>
      </div>

      <div class="listed-licenses">
        <div v-if="selectedLicenses.length > 0">
          <div v-for="(license, index) in selectedLicenses" :key="index" class="selected-licenses">
            <span>{{ license.name }}</span>
            <span :class="expirationDateColor(license.expirationDate)">
              {{ license.expirationDate }}
            </span>
            <!-- 
          <i class="material-icons-outlined align-middle" @click="$emit('removeLicense', license)">
            close
          </i> -->
          </div>
        </div>
        <div v-else>
          <div>Please select licenses from the list to proceed with renewal</div>
        </div>
      </div>
    </div>

    <div class="button-container">
      <button
        type="button"
        class="button-2-secondary"
        @click="closeRenewSidebar"
        :disabled="selectedLicenses.length === 0"
      >
        Cancel
      </button>

      <!-- <button
        type="button"
        class="button-2-primary"
        @click="updateLicenses"
        :disabled="isSaving || selectedLicenses.length === 0"
      >
        <i v-if="isSaving" class="material-icons align-middle spin-animation">refresh</i>
        <i v-else class="material-icons-outlined align-middle">autorenew</i>
        Renew Selected Licenses
      </button> -->

      <BaseButton class="button" @click="updateLicenses" :disabled="selectedLicenses.length === 0">
        <i class="material-icons-outlined align-middle">autorenew</i> Renew Selected
      </BaseButton>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';
  import SidebarContainer from '@/components/common/SidebarContainer.vue';
  import DeleteLicenseModal from './DeleteLicenseModal.vue';
  import { updateLicenses } from '@/api/organisation';
  import { GENERIC_ERROR_MESSAGE } from '@/constant/const';

  export default {
    name: 'RenewLicensesSidebar',

    components: { SidebarContainer, DeleteLicenseModal },

    props: {
      selectedLicenses: {
        type: Array,
        default: () => [],
      },
    },

    data() {
      return {
        isSaving: false,
        expirationDate: moment().add(1, 'day').format('yyyy-MM-DD'),
      };
    },

    computed: {
      organizationId() {
        if (this.selectedLicenses.length) {
          return this.selectedLicenses[0].organisation;
        }
        return null;
      },
    },
    methods: {
      async updateLicenses() {
        this.isSaving = true;
        if (!this.selectedLicenses.length) {
          this.$toasted.global.general_error({ message: 'No license selected' });
          return;
        }
        if (!this.expirationDate) {
          this.$toasted.global.general_error({ message: 'Expiration date is required' });
          return;
        }
        const today = moment().startOf('day');
        const started_at = moment().toISOString();
        const expired_time = moment(this.expirationDate).endOf('day').diff(today, 'day');
        const licenseIds = this.selectedLicenses.map((license) => license.id);

        try {
          const data = {
            started_at,
            expired_time,
            status: 'active',
          };
          await updateLicenses(this.organizationId, licenseIds, data);
          this.$toasted.global.general_success({
            message: 'Licenses are successfully renewed',
          });
          this.$emit('licensesUpdated');
          this.closeRenewSidebar();
        } catch (error) {
          this.$toasted.global.general_error({
            message:
              error?.response?.data?.message ?? error?.data?.message ?? GENERIC_ERROR_MESSAGE,
          });
        }
        this.isSaving = false;
      },

      closeRenewSidebar() {
        this.$emit('closeSidebar');
      },

      expirationDateColor(date) {
        const newDate = moment(date, 'DD/MM/YYYY').toDate();

        const colorClass = moment(newDate).isBefore() ? 'text-expired' : 'text-orange';

        return colorClass;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .full-sidebar {
    background-color: #fff;
    height: 100%;
    width: 20vw;
    max-width: 20vw;
    min-width: 20vw;
    font-size: 14px;
    position: relative;
    padding: 20px;
    margin-left: 8px;
  }

  .sidbar-first-section {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    max-height: 80%;
  }

  button {
    width: 100%;
  }
  .button-container {
    display: flex;
    flex-direction: column;
    gap: 8px;
    background-color: #fff;
    position: absolute;
    bottom: 20px;
    left: 20px;
    right: 20px;
  }

  .sidebar-heading {
    margin-bottom: 12px;
  }

  .selected-licenses {
    background-color: #f5f5f5;
    color: #0000 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    border-radius: 3px;
    padding: 10px;
    font-size: 12px;
    margin-bottom: 12px;
  }

  label {
    width: 100%;
  }

  .label {
    display: block;
    font-weight: bold;
    margin-bottom: 0px;
    padding-bottom: 0px;
    height: 21px;
  }

  .field {
    height: 44px;
    width: 100%;
    border: 2px solid #e8e8e8;
    border-radius: 8px;
    padding: 8px 16px;

    &:hover {
      border: solid 2px $borderGrey2;
    }

    &:disabled {
      border: 2px solid #e8e8e8;
    }
  }

  .listed-licenses {
    max-height: 65%;
    overflow: scroll;
    scrollbar-width: thin;
    margin-bottom: 20px;
  }
</style>
